import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  // bannerData: null,
  // recentNews: null,
  // trendingTags: null,
  // topNews: null
  topResults: null,
  topReviewsForSearch: null
};

// *************************** Fetch Banner ****************************
// const fetchBannerStart = (state = INITIAL_STATE, action) => {
//   return { ...state, loading: true };
// };

// const fetchBannerSuccess = (state = INITIAL_STATE, action) => {
//   return { ...state, bannerData: action.bannerData, loading: false };
// };

// const fetchBannerFailure = (state = INITIAL_STATE, action) => {
//   return { ...state, loading: false };
// };
// _____________________________________________________________________

// ************************ Fetch Trending Tags ************************
// const fetchTrendingTagsStart = (state = INITIAL_STATE, action) => {
//   return { ...state, loading: true };
// };

// const fetchTrendingTagsSuccess = (state = INITIAL_STATE, action) => {
//   return { ...state, trendingTags: action.trendingTags, loading: false };
// };

// const fetchTrendingTagsFailure = (state = INITIAL_STATE, action) => {
//   return { ...state, loading: false };
// };
// _____________________________________________________________________

// ************************* Fetch Top Results *************************
const fetchTopResultsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTopResultsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, topResults: action.topResults, loading: false };
};

const fetchTopResultsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Top News ***************************
const fetchTopReviewsForSearchStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTopReviewsForSearchSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    topReviewsForSearch: action.topReviewsForSearch,
    loading: false
  };
};

const fetchTopReviewsForSearchFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  // [Types.FETCH_BANNER_START]: fetchBannerStart,
  // [Types.FETCH_BANNER_FAILURE]: fetchBannerFailure,
  // [Types.FETCH_BANNER_SUCCESS]: fetchBannerSuccess,

  // [Types.FETCH_TRENDING_TAGS_START]: fetchTrendingTagsStart,
  // [Types.FETCH_TRENDING_TAGS_FAILURE]: fetchTrendingTagsFailure,
  // [Types.FETCH_TRENDING_TAGS_SUCCESS]: fetchTrendingTagsSuccess,

  [Types.FETCH_TOP_RESULTS_START]: fetchTopResultsStart,
  [Types.FETCH_TOP_RESULTS_FAILURE]: fetchTopResultsFailure,
  [Types.FETCH_TOP_RESULTS_SUCCESS]: fetchTopResultsSuccess,

  [Types.FETCH_TOP_REVIEWS_FOR_SEARCH_START]: fetchTopReviewsForSearchStart,
  [Types.FETCH_TOP_REVIEWS_FOR_SEARCH_FAILURE]: fetchTopReviewsForSearchFailure,
  [Types.FETCH_TOP_REVIEWS_FOR_SEARCH_SUCCESS]: fetchTopReviewsForSearchSuccess
};

// Create and Export Reducer
export const searchReducer = createReducer(INITIAL_STATE, HANDLERS);
